// extracted by mini-css-extract-plugin
module.exports = {"root":"TagsInput_root__9YgNs","label":"TagsInput_label__cQdL3","inputWrapper":"TagsInput_inputWrapper__PU46Q"};